// publicationAdvantageSearchDTOList parametresini hem array hem string olarak parse eden yardımcı fonksiyon
function parsePublicationAdvantageSearchDTOList(param) {
    if (!param) return [];
    if (Array.isArray(param)) return param;
    if (typeof param === "string") {
        try {
            // Try to parse directly first
            const parsed = JSON.parse(param);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            // If parsing failed, possibly the string is percent-encoded (double-encoded in some flows)
            try {
                let decoded = param;
                if (decoded.startsWith('%')) decoded = decodeURIComponent(decoded);
                // Try decode twice in rare double-encoded cases
                if (decoded.startsWith('%')) decoded = decodeURIComponent(decoded);
                const parsed2 = JSON.parse(decoded);
                return Array.isArray(parsed2) ? parsed2 : [];
            } catch {
                return [];
            }
        }
    }
    return [];
}
import React, { useEffect, useState, useContext } from "react";
import CourseHeader from "../../../header2/index-two";
import FeatherIcon from "feather-icons-react";
import { Footer2 } from "../../../footer2/index";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import { AppContext } from "../../../../services/AuthContext";
import { getUserFolders, updateFolderPublicationStatus, deleteFavoritePublication } from "../../../../services/userpanelservice";
import {
    AkademikDergiSayisi,
    AkademikKitapBolumu,
    AkademikKitap,
    AkademikMakale,
    Dergi,
    KonferansYazisi,
    Konferans,
    PopulerDergi,
    PopulerKitap,
    DefaultIcon,
} from "../../../imagepath";

import FilterPanel from "./components/FilterPanel";
import PublicationCard from "./components/PublicationCard";
import SortAndActionsBar from "./components/SortAndActionsBar";

import SaveModal from "./components/SaveModal";

import { Modal, Button } from 'react-bootstrap';
import { userInstutationDatabases } from '../../../../services/userService';
import { getCustomerInstitutionByIp, getCustomerInstitutionByToken } from "../../../../services/instutionscustomersService";

import { Helmet } from "react-helmet-async";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import queryString from 'query-string';

import Header from "../../../header/index";
import { useRef } from "react";
import CiteModal from './components/CiteModal';
import {
    generateAPA,
    generateMLA,
    generateChicago,
    generateBibTeX,
    generateVancouver
    // ... diğer formatlar
} from "./components/utils/citationFormats";
import axiosInstance from "../../../../services/axiosInstance";
import { getPublicationTypeList } from "../../../../services/publicationService";
import { getFilePath } from "../../../../services/axiosInstance";
import usePageTracking from "../../../../hooks/usePageTracking";

const CourseList = () => {
    usePageTracking("publication-list");
    const { auth } = useContext(AppContext);
    const headers = auth.token
        ? {
            Authorization: `Bearer ${auth.token}`,
        }
        : "";

    const navigate = useNavigate();
    const location = useLocation();
    const isFirstLoad = useRef(true);
    const urlSearchParams = useRef({ attributename: "" });
    const customStyles = {
        option: (base, { isFocused }) => {
            return {
                ...base,
                backgroundColor: isFocused ? "#FFDEDA" : "white",
            };
        },
    };

    const [extraFilters, setExtraFilters] = useState({});
    const [expandedCategory, setExpandedCategory] = useState(null);

    const [showSaveModal, setShowSaveModal] = useState(false);
    const [saveSummary, setSaveSummary] = useState(null);
    const [kaydetSelectedFolders, setKaydetSelectedFolders] = useState([]);
    const [kaydetFolders, setKaydetFolders] = useState([]);
    const [foldersLoading, setFoldersLoading] = useState(false);
    const [singlePublicationId, setSinglePublicationId] = useState(null);
    const [openSummaryId, setOpenSummaryId] = useState(null);
    const [instObj, setInstObj] = useState(null);
    const [instLogoUrl, setInstLogoUrl] = useState(null);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deletingPubId, setDeletingPubId] = useState(null);
    const [deletingBusy, setDeletingBusy] = useState(false);
    const [saveMode, setSaveMode] = useState(null);          // 'single' | 'multi' | null
    const [saveTargetIds, setSaveTargetIds] = useState([]);  // klasöre eklenecek net id listesi
    const [isLanded, setIsLanded] = useState(false);
    const [loading, setLoading] = useState(true);


    const handleRequestRemoveSaved = (id) => {
        setDeletingPubId(id);
        setShowDeleteConfirm(true);
    };

    const buildAggrPayload = (sf, userDb = []) => {
        const toObjArray = (arr, attrName) => {
            if (!Array.isArray(arr)) return [];
            return arr.map(v => (typeof v === "object" && v.searchkeyword)
                ? { typename: "publicationtypeInfo", attributename: v.attributename || attrName, searchkeyword: v.searchkeyword, noinclude: v.noinclude ?? "" }
                : { typename: "publicationtypeInfo", attributename: attrName, searchkeyword: v, noinclude: "" }
            );
        };

        const payload = {
            publicationAdvantageSearchDTOList: (sf.publicationAdvantageSearchDTOList?.length
                ? sf.publicationAdvantageSearchDTOList
                : [{ typename: "all", attributename: "", searchkeyword: "*", operator: "or" }]),
            permission: sf.permission ?? -1,
            documentTypes: sf.documentTypes ?? [],
            databases: (sf.databases?.length ? sf.databases : (Array.isArray(userDb) ? userDb : [])),
            languages: toObjArray(sf.languages, "Yayın Dili"),
            keywords: toObjArray(sf.keywords, "Anahtar Kelimeler"),
            topicTitles: toObjArray(sf.topicTitles, "Konu Başlıkları"),
            journals: toObjArray(sf.journals, "Dergi Adı"),
            publishers: sf.publishers ?? [],
            startyear: sf.startyear || undefined,
            endyear: sf.endyear || undefined,
            status: sf.status ?? 1
        };
        return payload;
    };

    // aggrtype eşlemesi (modal hangi kategori için çağrıldıysa)
    const mapCategoryToAggrType = (category) => {
        switch (category) {
            case "databases": return "databases";
            case "publishers": return "publishers";
            case "documentTypes": return "publicationtypes";
            case "permission": return "permission";
            case "languages": return "languages";
            case "keywords": return "keywords";
            case "journals": return "journals";
            default: return category; // backend’de varsa direkt kullan
        }
    };

    // --- CourseList.jsx: server’dan facet çek (modal kullanır) ---

    // --- Kategoriye göre facet verisini normalize eden yardımcı fonksiyon ---
    function parseAggrItems(category, data) {
        if (!data) return [];
        switch (category) {
            case "databases":
                return (data.databases || []).map(item => ({
                    label: item.key,
                    value: item.value
                }));
            case "publishers":
                return (data.publishers || []).map(item => ({
                    // prefer short key if provided by aggr (sortkey), else long key
                    label: (item.sortkey && item.sortkey.trim()) ? item.sortkey : item.key,
                    value: item.value
                }));
            case "documentTypes":
                // Sadece klasik publicationTypes (düz array) kullanılacak
                return (data.publicationTypes || []).map(item => ({
                    label: item.key,
                    value: item.value
                }));
            case "journals": {
                // parentList içindeki "Dergi Adı" arrayini kullan
                const arr = (data.parentList && Array.isArray(data.parentList["Dergi Adı"])) ? data.parentList["Dergi Adı"] : [];
                return arr.map(item => ({
                    label: item.key,
                    value: item.value
                }));
            }
            case "languages": {
                // publicationtypeInfo veya parentList içindeki "Yayın Dili" arrayini kullan
                let arr = [];
                if (data.publicationtypeInfo && Array.isArray(data.publicationtypeInfo["Yayın Dili"])) {
                    arr = data.publicationtypeInfo["Yayın Dili"];
                } else if (data.parentList && Array.isArray(data.parentList["Yayın Dili"])) {
                    arr = data.parentList["Yayın Dili"];
                }
                return arr.map(item => ({
                    label: item.key,
                    value: item.value
                }));
            }
            case "keywords": {
                // publicationtypeInfo veya parentList içindeki "Anahtar Kelimeler" arrayini kullan
                let arr = [];
                if (data.publicationtypeInfo && Array.isArray(data.publicationtypeInfo["Anahtar Kelimeler"])) {
                    arr = data.publicationtypeInfo["Anahtar Kelimeler"];
                } else if (data.parentList && Array.isArray(data.parentList["Anahtar Kelimeler"])) {
                    arr = data.parentList["Anahtar Kelimeler"];
                }
                return arr.map(item => ({
                    label: item.key,
                    value: item.value
                }));
            }
            default:
                return [];
        }
    }

    // --- CourseList.jsx: server’dan facet çek (modal kullanır) ---
    const fetchAggrItems = async (category) => {
        const aggrtype = mapCategoryToAggrType(category);
        const payload = buildAggrPayload(selectedFilters, userDatabase);

        const url = `publicationSearch/advantageAggrTypeSearchElastic`;
        const res = await axiosInstance.post(
            `${url}?aggrtype=${encodeURIComponent(aggrtype)}&aggrsize=1000`,
            payload,
            { headers }
        );

        const data = res?.data?.data ?? {};
        return parseAggrItems(category, data);
    };




    const buildInstLogoUrl = (inst) => {
        if (!inst?.id || !inst?.photo) return null;
        return getFilePath(`instutionscustomers/displayFile/${inst.id}/${inst.photo}`);
    };

    useEffect(() => {
        let isMounted = true;

        const fetchInstitutionForLogo = async () => {
            try {
                const token = auth?.token || sessionStorage.getItem("authToken");
                let data;

                if (token) {
                    // auth varken tek obje dönüyor
                    const res = await getCustomerInstitutionByToken(token);
                    data = res?.data || null;
                    // } else {
                    //     // auth yokken array dönüyor -> mümkünse foto’su olanı seç
                    //     const res = await getCustomerInstitutionByIp();
                    //     const arr = res?.data || [];
                    //     data = arr.find(x => x?.photo) || arr[0] || null;
                    // }
                } else {
                    // auth yokken array dönüyor -> şimdilik her zaman ilkini al
                    const res = await getCustomerInstitutionByIp();
                    const arr = res?.data || [];
                    data = arr[0] || null;
                }

                if (!isMounted) return;
                setInstObj(data || null);
                setInstLogoUrl(buildInstLogoUrl(data));
            } catch (e) {
                if (!isMounted) return;
                setInstObj(null);
                setInstLogoUrl(null);
            }
        };

        fetchInstitutionForLogo();
        return () => { isMounted = false; };
    }, [auth?.token]);


    const fetchFolders = async () => {
        setFoldersLoading(true);
        try {
            const response = await axiosInstance.post(
                "userpanel/userworkfoldersSearch?page=0&size=100",
                { searchkeyword: "" },
                { headers: { Authorization: `Bearer ${auth.token}` } }
            );
            setKaydetFolders(response.data.data || []);
        } catch (err) {
            console.error("Klasörler yüklenemedi.", err);
        }
        setFoldersLoading(false);
    };

    useEffect(() => {
        if (auth.token) {
            fetchFolders();
            getFavoritePublications();
        }
    }, []);

    const handleCreateFolder = async (folderName) => {
        try {
            await axiosInstance.post(
                "userpanel/userworkfolderCreate",
                { foldername: folderName, description: "" },
                { headers: { Authorization: `Bearer ${auth.token}` } }
            );
            toast.success("Klasör oluşturuldu");
            fetchFolders(); // tekrar yükle
        } catch (err) {
            toast.error("Klasör oluşturulamadı.");
        }
    };

    const handleAddToFolders = async (folderIds, publicationIds) => {
        try {
            await Promise.all(folderIds.map(folderId =>
                Promise.all(publicationIds.map(pubId =>
                    axiosInstance.post(
                        "userpanel/userworkfolderspublicationsCreate",
                        { userworkfolderid: folderId, publicationid: pubId },
                        { headers: { Authorization: `Bearer ${auth.token}` } }
                    )
                ))
            ));
            toast.success("Yayın(lar) klasöre kaydedildi");
        } catch (err) {
            toast.error("Klasöre eklenirken hata oluştu.");
        }
    };

    const handleExpandCategory = async (category) => {
        setExpandedCategory(category);
        // Loading state'i başlat
        setExtraFilters(prev => ({ ...prev, [category]: null })); // null = loading
        //burda seçili varsa onu,
        // databases listesi: seçili varsa onu, yoksa onlySubscribed durumuna göre karar ver
        let sendExpandedDBs = Array.isArray(selectedFilters?.databases)
            ? selectedFilters.databases
            : [];

        if (!sendExpandedDBs.length) {
            if (selectedFilters?.onlySubscribed) {
                // onlySubscribed seçiliyse kullanıcının abone olduğu veritabanlarını kullan
                sendExpandedDBs = Array.isArray(userDatabase) ? userDatabase : [];
            } else {
                // onlySubscribed seçili değilse boş bırak (sorgudan gelen default'u kullan)
                sendExpandedDBs = [];
            }
        }


        const dynamicFilters = {
            publicationAdvantageSearchDTOList: [{
                typename: "all",
                attributename: "",
                searchkeyword: "*",
                operator: "or"
            }],
            permission: selectedFilters?.permission ?? -1,
            documentTypes: selectedFilters?.documentTypes ?? [],
            databases: sendExpandedDBs,                   // <- artık erişilebilir
            languages: selectedFilters?.languages ?? [],
            journals: selectedFilters?.journals ?? [],
            keywords: selectedFilters?.keywords ?? [],
            publishers: selectedFilters?.publishers ?? [],
            topicTitles: selectedFilters?.topicTitles ?? [],
            status: 1,
            pdffile: -1,
            identifier: ""
        };

        // tıklanan kategori sıfırlansın
        if (category in dynamicFilters) {
            if (category === "databases") {
                dynamicFilters[category] = [];
            }
            else {
                dynamicFilters[category] = [];
            }
        }

        try {
            const response = await axiosInstance.post(
                "publicationSearch/advantageAggrSearchElastic",
                dynamicFilters,
                { headers }
            );
            const data = response?.data?.data ?? {};

            let newOptions = [];
            switch (category) {
                case "documentTypes":
                    newOptions = data.publicationTypes?.map(pt => ({ value: pt.value, label: pt.key })) ?? [];
                    break;
                case "databases":
                    // onlySubscribed seçiliyse kullanıcının abone olduğu veritabanları ile eşleştir
                    // seçili değilse sorgudan gelen tüm veritabanlarını göster
                    newOptions = selectedFilters?.onlySubscribed
                        ? data.databases?.filter(db => userDatabase.includes(db.key)).map(db => ({ value: db.value, label: db.key }))
                        : data.databases?.map(db => ({ value: db.value, label: db.key }));
                    break;
                case "journals":
                    newOptions = toTrJournalOptions(data.parentList?.["Dergi Adı"] || []);
                    break;
                case "languages":
                    newOptions = data.publicationtypeInfo?.["Yayın Dili"]?.map(lang => ({ value: lang.value, label: lang.key })) ?? [];
                    break;
                case "publishers":
                    // advantageAggrSearchElastic: prefer sortkey if present
                    newOptions = data.publishers?.map(pub => ({ value: pub.value, label: (pub.sortkey && pub.sortkey.trim()) ? pub.sortkey : pub.key })) ?? [];
                    break;
                default:
                    newOptions = [];
            }

            const selected = selectedFilters?.[category] ?? [];
            const selectedLabels = selected.map(f => f?.searchkeyword ?? f);
            const filteredOptions = newOptions.filter(opt => !selectedLabels.includes(opt.label));

            setExtraFilters(prev => ({ ...prev, [category]: filteredOptions }));
        } catch (e) {
            setExtraFilters(prev => ({ ...prev, [category]: [] }));
        }
    };

    const handleAddToFavorites = async (pub) => {
        try {
            const response = await axiosInstance.post(
                "userpanel/favoritepublicationsAdd",
                {
                    userid: auth.id,
                    publicationid: pub.mysqlId,
                    status: 1
                },
                {
                    headers: {
                        Authorization: `Bearer ${auth.token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            toast.success(response.data.message || "Kütüphaneye başarıyla eklendi.");
            setSaveSummary({
                total: 1,
                added: 1,
                existing: 0,
            });
        } catch (error) {
            const errorMsg =
                error?.response?.data?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
            toast.error(errorMsg);
            console.error("Kütüphaneye ekleme hatası:", error);
            // setSaveSummary({
            //     total: 1,
            //     added: 0,
            //     existing: 1,
            // });
            throw error; // hatayı üst fonksiyona ilet
        }
    };

    const handleSingleSaveWithModal = async (pub) => {
        try {
            await handleAddToFavorites(pub); // önce favorilere ekle

            setSinglePublicationId(pub.mysqlId);
            setSaveMode('single');
            setSaveTargetIds([Number(pub.mysqlId)]);
            setShowSaveModal(true);

            await getFavoritePublications(); // favorileri güncelle

        } catch (err) {
            console.error("Tekli favoriye ekleme hatası:", err);
        }
    };


    const handleMultipleAddToFavorites = async (pubs) => {
        try {
            const payload = pubs.map(pub => ({
                userid: auth.id,
                publicationid: pub.mysqlId,
                status: 1,
                adddate: new Date().toISOString(),
                updatedate: new Date().toISOString(),
            }));
            const response = await axiosInstance.post(
                "userpanel/favoritepublicationsAddList",
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${auth.token}`,
                        "Content-Type": "application/json"
                    }
                }
            );
            // toast.success kaldırılabilir çünkü modal üstü mesaj kullanılacak
            return true; // başarılı
        } catch (error) {
            const errorMsg =
                error?.response?.data?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
            toast.error(errorMsg);
            console.error("Toplu kütüphaneye ekleme hatası:", error);
            return false; // başarısız
        }
    };


    const option = [
        { label: "Newly published", value: "Newly published" },
        { label: "published 1", value: "published 1" },
        { label: "published 2", value: "published 2" },
        { label: "published 3", value: "published 3" },
    ];
    const optionSonucSayisi = [
        { label: "20", value: "20" },
        { label: "50", value: "50" },
        { label: "100", value: "100" }
    ];

    const [userDatabase, setUserDatabase] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    // Klasöre ekle (single veya multiple) — favorilerden SİLME YOK
    const handleAddPublicationsToFolder = async (folderId) => {
        const ids = Array.isArray(saveTargetIds) ? saveTargetIds : [];
        if (!ids.length) {
            toast.info("Lütfen tekli kaydetten açın ya da yayın seçin.");
            return;
        }
        try {
            if (ids.length === 1) {
                await axiosInstance.post(
                    "userpanel/userworkfolderspublicationsCreate",
                    { userworkfolderid: folderId, publicationid: ids[0] },
                    { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } }
                );
                toast.success("Yayın klasöre kaydedildi.");
            } else {
                const payload = ids.map((id) => ({
                    userworkfolderid: folderId,
                    publicationid: Number(id),
                }));
                const resp = await axiosInstance.post(
                    "userpanel/userworkfolderspublicationsCreateList",
                    payload,
                    { headers: { Authorization: `Bearer ${auth.token}`, "Content-Type": "application/json" } }
                );
                const count = resp.data?.count ?? 0;
                toast.info(count === 0 ? "Seçilen yayınlar zaten bu klasörde." : `${count} yayın klasöre kaydedildi.`);
            }
            setKaydetSelectedFolders((prev) => (prev.includes(folderId) ? prev : [...prev, folderId]));
        } catch (err) {
            toast.error("Klasöre eklenirken bir hata oluştu.");
            console.error(err);
        }
    };


    const handleAddSinglePublicationToFolder = async (folderId, publicationid) => {
        if (!publicationid || !folderId) return;

        try {
            const response = await axiosInstance.post(
                "userpanel/userworkfolderspublicationsCreate",
                {
                    userworkfolderid: folderId,
                    publicationid: Number(publicationid),
                },
                {
                    headers: {
                        Authorization: `Bearer ${auth.token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            toast.success("Yayın klasöre kaydedildi.");

            setKaydetSelectedFolders((prev) =>
                prev.includes(folderId) ? prev : [...prev, folderId]
            );
        } catch (err) {
            toast.error("Zaten bu klasörde olabilir.");
            console.error(err);
        }
    };


    useEffect(() => {
        const loadUserDatabase = async () => {
            try {
                const response = await userInstutationDatabases(auth.token);
                const names = response.data.map((item) => item.name);
                setUserDatabase(names);
                setErrorMessage(null);
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    setErrorMessage(error.response.data.message);
                } else {
                    setErrorMessage("Bir hata oluştu. Lütfen tekrar deneyin.");
                }
                setUserDatabase([]); // Hata olursa yine array olarak bırakıyoruz
            }
        };
        loadUserDatabase();
    }, [auth.token]);



    // publicationAdvantageSearchDTOList parametresini fonksiyonel olarak parse et
    const initialDTOList = parsePublicationAdvantageSearchDTOList(location?.state?.publicationAdvantageSearchDTOList) || [{
        "typename": "all",
        "attributename": "",
        "searchkeyword": "*",
        "operator": "or"
    }];

    const [filters, setFilters] = useState({
        publicationAdvantageSearchDTOList: initialDTOList,
        permission: -1,
        databases: [],
        languages: [],
        documentTypes: [],
        keywords: [],
        publishers: [],
        topicTitles: [],
        startyear: "",
        endyear: "",
        journals: [],
        status: 1,
    });

    const [selectedFilters, setSelectedFilters] = useState({
        publicationAdvantageSearchDTOList: initialDTOList,
        permission: -1,
        databases: [],
        languages: [],
        documentTypes: [],
        keywords: [],
        publishers: [],
        topicTitles: [],
        startyear: "",
        endyear: "",
        journals: [],
        status: 1,
        onlySubscribed: false,
    });

    const [input, setInput] = useState(null);

    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);


    const [publications, setPublications] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [newpagesize, setNewPageSize] = useState(20);
    // totalPublication stays as the raw count from API (for display)
    const [totalPublication, setTotalPublication] = useState(0);
    // paginatedTotalPublication is capped at 10000 and used only for pagination calculations
    const [paginatedTotalPublication, setPaginatedTotalPublication] = useState(0);

    // derive initial query from location.state but avoid '*' sentinel in UI
    const query = location?.state?.publicationAdvantageSearchDTOList[0]?.searchkeyword || "";
    const attributename = location?.state?.publicationAdvantageSearchDTOList[0]?.attributename || "";

    const [searchInput, setSearchInput] = useState(query);
    const [lastSearchKeyword, setLastSearchKeyword] = useState(query);

    // Start as loading=true so initial render shows spinner until first fetch


    const handleApplyModalSelections = (category, selections) => {
        setSelectedFilters(prev => ({
            ...prev,
            [category]: Array.isArray(selections) ? selections : []
        }));
        // listede başa dön
        setCurrentPage(1);
    };


    const toTrJournalOptions = (list = []) =>
        list
            .filter(j => String((j.lang ?? 'tr')).toLowerCase() === 'tr')
            .map(j => ({ value: j.value, label: j.key }));


    const fetchFilters = async () => {
        try {
            const filtersToSend = { ...selectedFilters };

            const mapToObj = (arr, attrName) => {
                if (!arr) return [];
                return arr.map(val =>
                    typeof val === "object" && val.typename && val.attributename
                        ? val
                        : {
                            typename: "publicationtypeInfo",
                            attributename: attrName,
                            searchkeyword: val.searchkeyword || val
                        }
                );
            };
            filtersToSend.journals = mapToObj(filtersToSend.journals, "Dergi Adı");
            filtersToSend.languages = mapToObj(filtersToSend.languages, "Yayın Dili");
            filtersToSend.keywords = mapToObj(filtersToSend.keywords, "Anahtar Kelimeler");

            if (filtersToSend.endyear == "") {
                delete filtersToSend.endyear;
            }
            if (filtersToSend.startyear == "") {
                delete filtersToSend.startyear;
            }
            if (filtersToSend.databases.length === 0) {
                if (filtersToSend.onlySubscribed) {
                    // sadece abone olunan içerikler seçiliyse
                    filtersToSend.databases = Array.isArray(userDatabase) ? userDatabase : [];
                } else {
                    // ilk çağrı veya normal boş durum
                    filtersToSend.databases = [];
                }
            }

            const response = await axiosInstance.post(
                "publicationSearch/advantageAggrSearchElastic",
                filtersToSend,
                {
                    headers: headers,
                }
            );

            if (response.data.status === "OK") {
                const rawData = response.data.data;
                const rawDbList = rawData?.databases || [];

                // onlySubscribed seçiliyse kullanıcının abone olduğu veritabanları ile eşleştir
                // seçili değilse sorgudan gelen tüm veritabanlarını göster
                const intersectedDatabases = selectedFilters?.onlySubscribed
                    ? rawDbList
                        .filter(db => userDatabase.includes(db.key))  // sadece kullanıcıya ait olanlar
                        .map(db => ({
                            value: db.value,
                            label: db.key
                        }))
                    : rawDbList.map(db => ({
                        value: db.value,
                        label: db.key
                    }));
                setFilters({
                    databases: intersectedDatabases,
                    publicationTypes: rawData?.publicationTypes?.map((pt) => ({
                        value: pt.value,
                        label: pt.key,
                    })),
                    publishers: rawData?.publishers?.map((pub) => ({
                        value: pub.value,
                        // sortkey varsa onu kullan, yoksa key'i kullan
                        label: (pub.sortkey && pub.sortkey.trim()) ? pub.sortkey : pub.key,
                    })),
                    keywords:
                        rawData?.publicationtypeInfo["Anahtar Kelimeler"]?.map((k) => ({
                            value: k.value,
                            label: k.key,
                        })) || [],
                    languages:
                        rawData?.publicationtypeInfo["Yayın Dili"]?.map((l) => ({
                            value: l.value,
                            label: l.key,
                        })) || [],
                    publicationDates:
                        rawData?.templateInfo["Yayın Tarihi"]?.map((d) => ({
                            value: d.value,
                            label: d.key,
                        })) || [],
                    journals:
                        toTrJournalOptions(rawData?.parentList["Dergi Adı"] || []),

                    // Dinamik erişim türü filtresi
                    permission:
                        rawData?.permission?.map((p) => ({
                            value: p.key,
                            label:
                                p.key === -1
                                    ? "Tümü"
                                    : p.key === 1
                                        ? "Açık Erişim"
                                        : p.key === 0
                                            ? "Kapalı Erişim"
                                            : p.key === 2
                                                ? "Hibrit"
                                                : String(p.key),
                            count: p.value,
                        })) || [],
                });


            }
        } catch (error) {
            console.error("Error fetching filters:", error);
        }
    };

    // Dergi filtresi aktif mi?
    const isJournalOnly = (
        (selectedFilters.documentTypes && selectedFilters.documentTypes.length === 1 && selectedFilters.documentTypes[0] === "Dergi") ||
        (
            selectedFilters.publicationAdvantageSearchDTOList &&
            selectedFilters.publicationAdvantageSearchDTOList.length === 1 &&
            (
                selectedFilters.publicationAdvantageSearchDTOList[0].typename === "Dergi" ||
                selectedFilters.publicationAdvantageSearchDTOList[0].attributename === "Dergi"
            )
        )
    );

    const sortMapping = {
        "interest": { ordertype: "desc", orderfield: "relevance" },
        "year_desc": {
            ordertype: "desc",
            orderfield: isJournalOnly ? "publicationtypeInfo.Yayın Tarihi" : "publicationtypeInfo.Yayın Tarihi"
        },
        "year_asc": {
            ordertype: "asc",
            orderfield: isJournalOnly ? "publicationtypeInfo.Yayın Tarihi" : "publicationtypeInfo.Yayın Tarihi"
        }
    };

    const fetchPublications = async (page = 1, sortType = selectedSort, pageSize = newpagesize) => {

        setExpandedCategory(null);
        const start = parseInt(selectedFilters.startyear, 10);
        const end = parseInt(selectedFilters.endyear, 10);
        if (start && end && start > end) {
            toast.error("Başlangıç yılı, bitiş yılından büyük olamaz!");
            return;
        }

        setLoading(true);
        setIsLanded(false);

        try {
            const filtersToSend = { ...selectedFilters };

            // --- DİL ve DERGİ DOĞRU FORMAT ---
            const mapToObj = (arr, attrName) => {
                if (!arr) return [];
                return arr.map(val =>
                    typeof val === "object" && val.typename && val.attributename
                        ? val
                        : {
                            typename: "publicationtypeInfo",
                            attributename: attrName,
                            searchkeyword: val.searchkeyword || val
                        }
                );
            };

            filtersToSend.journals = mapToObj(filtersToSend.journals, "Dergi Adı");
            filtersToSend.languages = mapToObj(filtersToSend.languages, "Yayın Dili");
            filtersToSend.keywords = mapToObj(filtersToSend.keywords, "Anahtar Kelimeler");
            // --------------------------------

            if (filtersToSend.endyear == 0) {
                delete filtersToSend.endyear;
            }
            if (filtersToSend.startyear == 0) {
                delete filtersToSend.startyear;
            }
            if ((filtersToSend.databases.length === 0) && userDatabase.length > 0) {
                if (filtersToSend.databases.length === 0) {
                    if (filtersToSend.onlySubscribed) {
                        // sadece abone olunan içerikler seçiliyse
                        filtersToSend.databases = Array.isArray(userDatabase) ? userDatabase : [];
                    } else {
                        // ilk çağrı veya normal boş durum
                        filtersToSend.databases = [];
                    }
                }

            }

            // publicationAdvantageSearchDTOList yoksa, location.state'den al
            if (!filtersToSend.publicationAdvantageSearchDTOList || filtersToSend.publicationAdvantageSearchDTOList.length === 0) {
                if (location.state && location.state.publicationAdvantageSearchDTOList) {
                    filtersToSend.publicationAdvantageSearchDTOList = location.state.publicationAdvantageSearchDTOList;
                } else {
                    filtersToSend.publicationAdvantageSearchDTOList = [{
                        "typename": "all",
                        "attributename": "",
                        "searchkeyword": "*",
                        "operator": "or"
                    }];
                }
            }

            const { ordertype, orderfield } = sortMapping[sortType] || {};
            try {
                const dtoListForDisplay = Array.isArray(filtersToSend.publicationAdvantageSearchDTOList)
                    ? filtersToSend.publicationAdvantageSearchDTOList
                    : parsePublicationAdvantageSearchDTOList(filtersToSend.publicationAdvantageSearchDTOList);
                const sk = (dtoListForDisplay && dtoListForDisplay.length > 0) ? (dtoListForDisplay[0].searchkeyword || "") : "";
                const displayKeyword = sk === '*' ? '' : sk;
                setSearchInput(displayKeyword);
                setLastSearchKeyword(displayKeyword);
            } catch (e) {
                // ignore
            }

            try {
                const response = await axiosInstance.post(
                    `publicationSearch/advantageSearchElastic`,
                    filtersToSend,
                    {
                        params: {
                            page: page,
                            newpagesize: pageSize,
                            ordertype: ordertype,
                            orderfield: orderfield,
                        },
                        headers: headers,
                    }
                );
                if (response.data && response.data.status === "OK") {
                    setPublications(response.data.data);
                    const rawTotalItems = response.data.count || 0;
                    // keep the raw total for display
                    setTotalPublication(rawTotalItems);
                    // but cap the value used for pagination to 10k
                    const cappedTotalItems = rawTotalItems > 10000 ? 10000 : rawTotalItems;
                    setPaginatedTotalPublication(cappedTotalItems);
                    setTotalPages(Math.ceil(cappedTotalItems / pageSize));
                    await fetchFilters();
                    setLoading(false);
                    setIsLanded(true);
                }
            } catch (error) {
                // nothing
            }

        } catch (error) {
            setPublications([]);
            setTotalPages(0);
            setTotalPublication(0);
            setPaginatedTotalPublication(0);
        } finally {
            // nothing
        }
    };

    const closeSaveModal = () => {
        setSaveMode(null);
        setSaveTargetIds([]);
        setSinglePublicationId(null);
        setShowSaveModal(false);
    };



    // useEffect(() => {
    //     setPublications([]);
    //     fetchPublications();
    // }, [
    //     selectedFilters.publicationAdvantageSearchDTOList,
    //     selectedFilters.permission,
    //     selectedFilters.databases,
    //     selectedFilters.languages,
    //     selectedFilters.documentTypes,
    //     selectedFilters.keywords,
    //     selectedFilters.publishers,
    //     selectedFilters.topicTitles,
    //     selectedFilters.journals,
    //     newpagesize,
    //     userDatabase
    // ]);

    const handleCheckboxChange = (category, item) => {
        setSelectedFilters(prev => {
            if (category === "onlySubscribed") {
                return { ...prev, onlySubscribed: item }; // item burada true/false
            }
            if (category === "permission") {
                return { ...prev, permission: item.value };
            }
            const selected = prev[category] || [];
            let newSelected;
            // For keywords, journals, languages: use searchkeyword property
            if (["keywords", "journals", "languages"].includes(category)) {
                if (selected.some(f => f.searchkeyword === item.label)) {
                    newSelected = selected.filter(f => f.searchkeyword !== item.label);
                } else {
                    newSelected = [...selected, { searchkeyword: item.label }];
                }
            } else {
                if (selected.includes(item.label)) {
                    newSelected = selected.filter(l => l !== item.label);
                } else {
                    newSelected = [...selected, item.label];
                }
            }
            return { ...prev, [category]: newSelected };
        });
        setCurrentPage(1); // Filtre değişikliğinde sayfa 1'e dön
    };


    const clearFilters = () => {
        setSelectedFilters({
            publicationAdvantageSearchDTOList: [],
            permission: -1,
            documentTypes: [],
            databases: [],
            languages: [],
            journals: [],
            keywords: [],
            publishers: [],
            topicTitles: [],
            status: 1,
            pdffile: -1,
            identifier: ""
        });
        setSearchInput("");
        setCurrentPage(1); // Filtreler temizlendiğinde sayfa 1'e dön
    };


    const [selectedArticles, setSelectedArticles] = useState([]);
    const handleCheckboxChange2 = (id) => {
        setSelectedArticles((prevSelected) =>
            prevSelected.includes(String(id))
                ? prevSelected.filter((articleId) => articleId !== String(id))
                : [...prevSelected, String(id)]
        );
    };

    const [parentTitles, setParentTitles] = useState({});

    const fetchParentTitles = async (initialParentId) => {
        let currentParentId = initialParentId;
        let titles = [];

        while (currentParentId) {
            try {

                const response = await axiosInstance.get(
                    `publications/publicationdetail/${currentParentId}/-1`,
                    {
                        headers: headers,
                    }
                );

                if (response.data && response.data.data.elasticjson) {
                    const title =
                        response.data.data.publicationtypeInfo.find(
                            (attr) => attr.attributename === "Başlık"
                        )?.value[0]?.value[0] ||
                        response.data.data.templateInfo.find(
                            (attr) => attr.attributename === "Başlık"
                        )?.value[0]?.value[0] ||
                        response.data.data.publicationtypeInfo.find(
                            (attr) => attr.attributename === "Dergi Adı"
                        )?.value[0]?.value[0] ||
                        response.data.data.templateInfo.find(
                            (attr) => attr.attributename === "Dergi Adı"
                        )?.value[0]?.value[0] ||
                        "-";

                    titles.unshift(title);
                    currentParentId = response.data.data.parentid;
                } else {
                    break;
                }
            } catch (error) {
                console.error(`Error fetching parent title for ${currentParentId}:`, error);
                break;
            }
        }

        return titles.join(" / ");
    };

    useEffect(() => {
        const loadParentTitles = async () => {
            for (let pub of publications) {
                const parentId = pub.elasticjson?.parentid;
                if (parentId && !parentTitles[parentId]) {
                    const titles = await fetchParentTitles(parentId);
                    setParentTitles((prevTitles) => ({
                        ...prevTitles,
                        [pub.mysqlId]: titles,
                    }));
                }
            }
        };

        loadParentTitles();
    }, [publications]);




    const iconMap = {
        "Akademik Dergi Sayısı": AkademikDergiSayisi,
        "Akademik Kitap Bölümü": AkademikKitapBolumu,
        "Akademik Kitap": AkademikKitap,
        "Akademik Makale": AkademikMakale,
        "Dergi": Dergi,
        "Konferans ve Armağan Yazısı": KonferansYazisi,
        "Konferans ve Armağan": Konferans,
        "Popüler Dergi Sayısı": PopulerDergi,
        "Popüler Kitap": PopulerKitap,
    };

    const getIcon = (type) => iconMap[type] || DefaultIcon;


    const [showModal, setShowModal] = useState(false);
    const [selectedFormat, setSelectedFormat] = useState('');
    const [selectedPublication, setSelectedPublication] = useState(null);

    const getAttrValue = (arr, name) => {
        return arr?.find(attr => attr.attributename === name)?.value?.[0]?.value?.[0] || "";
    };

    const getParentInfo = (pub, attr) => {
        return pub.parentList?.flatMap(p =>
            p.publicationtypeInfo?.filter(i => i.attributename === attr)
        )?.[0]?.value?.[0]?.value?.[0] || "";
    };

    const getJournalTitle = (pub) => {
        const journalParent = pub.parentList?.find(p =>
            p.publicationtypeInfo?.some(info =>
                info.attributename === "Yayın Türü" &&
                info.value?.[0]?.value?.[0] === "Dergi"
            )
        );
        return journalParent?.publicationtypeInfo?.find(i => i.attributename === "Başlık")?.value?.[0]?.value?.[0] || "Unknown Journal";
    };

    const getYear = (pub) => {
        const date = getAttrValue(pub.templateInfo, "Yayın Tarihi") || getAttrValue(pub.publicationtypeInfo, "Yayın Tarihi");
        return date.split(" ")[0].split("-")[0];
    };

    const getPages = (pub) => {
        const first = getAttrValue(pub.publicationtypeInfo, "İlk Sayfa");
        const last = getAttrValue(pub.publicationtypeInfo, "Son Sayfa");
        return first && last ? `${first}-${last}` : "N/A";
    };

    const getVolume = (pub) => getParentInfo(pub, "Cilt");
    const getIssue = (pub) => getParentInfo(pub, "Sayı");

    const getAuthors = (pub) => {
        const unique = [...new Map(pub.authors.map(a => [`${a.name} ${a.surname}`, a])).values()];
        return unique.map(a => `${a.name} ${a.surname}`);
    };

    const getDOI = (pub) =>
        pub.publicationtypeInfo?.find(attr => attr.attributename === "DOI")?.value?.[0]?.value?.[0] || "";

    // Citation Formats
    const citationFormats = {
        apa: generateAPA,
        mla: generateMLA,
        chicago: generateChicago,
        vancouver: generateVancouver,
        bibtex: generateBibTeX,
        // ... diğerleri
    };

    // Open Modal
    const handleOpenModal = (publication) => {
        setSelectedPublication(publication);
        setShowModal(true);
    };


    // Handle keyword click to trigger a new search for that keyword
    const handleKeywordClick = (keyword) => {
        window.open(`/publication-list?databases=&documentTypes=&endyear=&journals=&keywords=${encodeURIComponent(keyword)}&languages=&permission=-1&publicationAdvantageSearchDTOList=&publishers=&startyear=&status=1&topicTitles=`, "_blank");
    };

    // Klasöre tıklama:
    const handleToggleFolder = (folderId, checked) => {
        setKaydetSelectedFolders(prev =>
            checked ? [...prev, folderId] : prev.filter(id => id !== folderId)

        );
        if (checked) {
            handleAddPublicationsToFolder(folderId); // sadece ekleme durumunda çağır
        }
    };


    const handleSearchSubmit = (e) => {
        e.preventDefault();
        // Yeni arama yapıldığında sayfa 1'e dön
        setCurrentPage(1);

        // --- "Dergi Adı" seçiliyse journal-list/all'a git ---
        if (selectedOption?.attributename === "Dergi Adı") {
            navigate(`/journal-list/all`, {
                state: {
                    databasename: "",
                    searchkeyword: searchInput || "",
                    topicname: "",
                    searchtype: searchInput ? "journalName" : "",
                },
            });
            return;
        }

        const isIssn = (selectedOption?.attributename === "ISSN" || selectedOption?.attributename === "E-ISSN" || selectedOption?.attributename === "EISSN") && (searchInput || "").trim() !== "";

        const updatedSearchDTO = [
            {
                typename: selectedOption?.typename || "all",
                attributename: selectedOption?.attributename || "",
                searchkeyword: searchInput || "*",
                operator: "or",
            },
        ];
        setSelectedFilters((prevFilters) => {
            const exactAttr = (selectedOption?.attributename === "E-ISSN" || selectedOption?.attributename === "EISSN") ? "E-ISSN" : "ISSN";
            const cleanJournals = isIssn
                ? [{ typename: "publicationtypeInfo", attributename: exactAttr, searchkeyword: searchInput || "" }]
                : (prevFilters.journals || []).filter(j => j.attributename !== "ISSN" && j.attributename !== "E-ISSN");

            const newFilters = {
                ...prevFilters,
                publicationAdvantageSearchDTOList: isIssn
                    ? [{ typename: "all", attributename: "", searchkeyword: "*", operator: "or" }]
                    : updatedSearchDTO,
                journals: cleanJournals,
            };
            // Arama aynı olsa bile fetch'i tetikle
            setTimeout(() => {
                // setPublications([]);
                // fetchPublications(1, selectedSort, newpagesize);
            }, 0);
            return newFilters;
        });
        setLastSearchKeyword(searchInput || ""); // <-- sadece arama yapıldığında güncellenir
    };

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const res = await getPublicationTypeList();
                const data = res?.data ?? [];
                if (res.status && res.status !== "OK") return;
                if (res.status === "OK") {
                    let processedData = [...data];
                    processedData.forEach(item => {
                        if (item.webname === "EISSN") {
                            item.webname = "E-ISSN";
                        }
                        if (item.webname === "EISBN") {
                            item.webname = "E-ISBN";
                        }
                    });

                    // "Dergi Adı" ekle (eğer yoksa)
                    const dergiAdiExists = processedData.some(it => it.webname === "Dergi Adı");
                    if (!dergiAdiExists) {
                        processedData.push({
                            webname: "Dergi Adı",
                            typename: "parentList",
                            attributename: "Dergi Adı"
                        });
                    }


                    const sortOrder = [
                        "Tümü",
                        "Başlık",
                        "Anahtar Kelime",
                        "Özet",
                        // "Konu Başlıkları",
                        "İçerik",
                        "Yazar",
                        "Dergi Adı",
                        "ISBN",
                        "ISSN",
                        "E-ISBN",
                        "E-ISSN"
                    ];


                    processedData.sort((a, b) => {
                        const indexA = sortOrder.indexOf(a.webname);
                        const indexB = sortOrder.indexOf(b.webname);
                        if (indexA === -1 && indexB === -1) return 0;

                        if (indexA === -1) return 1;

                        if (indexB === -1) return -1;

                        return indexA - indexB;
                    });


                    // 4. Sıralanmış ve düzenlenmiş veriyi state için formatlayalım
                    // Filtre: dropdown'da göstermemek istediğimiz webname'leri çıkaralım
                    const excludeLower = new Set(["cilt", "sayı", "yayın yeri", "konu başlıkları"]);
                    const formattedOptions = processedData
                        .filter(item => {
                            const name = (item.webname || "").toString().trim().toLowerCase();
                            return !excludeLower.has(name);
                        })
                        .map((item) => ({
                            value: item.webname,
                            label: item.webname === "İçerik" ? "Tam Metin" : item.webname,
                            typename: item.typename,
                            attributename: item.attributename,
                        }));

                    setOptions(formattedOptions);

                    // URL'den gelen `attributename`'e göre varsayılan seçimi yap
                    const defaultOption = formattedOptions.find(
                        (option) => option.attributename === attributename
                    );

                    if (defaultOption) {
                        setSelectedOption(defaultOption);
                    }
                }
            } catch (error) {
                console.error("Error fetching options:", error);
            }
        };

        fetchOptions();
    }, []); // Bu hook sadece component ilk yüklendiğinde çalışır


    const removeFilter = (category, value) => {
        setSelectedFilters((prevFilters) => {
            // special handling for documentTypes: if user clicks merged badge (Kitap / Kitap Bölümü)
            const lower = (s) => (String(s || '').toLowerCase());
            const journalDbVariants = ['akademik dergiler', 'popüler dergiler', 'populer dergiler'];
            const bookVariants = ['akademik kitap', 'popüler kitap', 'populer kitap'];
            const bookSectionVariants = ['akademik kitap bölümü', 'popüler kitap bölümü', 'populer kitap bolumu', 'populer kitap bölümü', 'akademik kitap bolumu'];

            if (["keywords", "languages", "journals"].includes(category)) {
                return {
                    ...prevFilters,
                    [category]: prevFilters[category].filter(
                        (filter) => filter.searchkeyword !== value
                    ),
                };
            }

            if (category === 'databases') {
                if (value === 'İdealonline Süreli Yayınlar') {
                    return {
                        ...prevFilters,
                        databases: prevFilters.databases.filter(item => !journalDbVariants.includes(lower(item)))
                    };
                }
                return {
                    ...prevFilters,
                    [category]: prevFilters[category].filter((item) => item !== value),
                };
            }

            if (category === 'documentTypes') {
                // if user clicked the combined display label, remove underlying variants
                if (value === 'Kitap') {
                    return {
                        ...prevFilters,
                        documentTypes: prevFilters.documentTypes.filter(item => !bookVariants.includes(lower(item)))
                    };
                }
                if (value === 'Kitap Bölümü' || value === 'Kitap Bolümü') {
                    return {
                        ...prevFilters,
                        documentTypes: prevFilters.documentTypes.filter(item => !bookSectionVariants.includes(lower(item)))
                    };
                }
                // otherwise remove exact match
                return {
                    ...prevFilters,
                    [category]: prevFilters[category].filter((item) => item !== value),
                };
            }

            return {
                ...prevFilters,
                [category]: prevFilters[category].filter((item) => item !== value),
            };
        });
        setCurrentPage(1);
    };

    const ALLOWED_SORTS = ["year_desc", "year_asc", "interest"];
    const ALLOWED_SIZES = [20, 50, 100];


    const buildQueryForURL = (selectedFilters, selectedSort, newpagesize, page) => {
        const getArray = arr => Array.isArray(arr) ? arr.map(x => x?.searchkeyword || x) : [];
        return {
            databases: getArray(selectedFilters.databases),
            languages: getArray(selectedFilters.languages),
            documentTypes: getArray(selectedFilters.documentTypes),
            keywords: getArray(selectedFilters.keywords),
            publishers: getArray(selectedFilters.publishers),
            topicTitles: getArray(selectedFilters.topicTitles),
            journals: getArray(selectedFilters.journals),
            startyear: selectedFilters.startyear || "",
            endyear: selectedFilters.endyear || "",
            permission: selectedFilters.permission,
            status: selectedFilters.status,
            publicationAdvantageSearchDTOList: JSON.stringify(
                selectedFilters.publicationAdvantageSearchDTOList || []
            ),
            sort: selectedSort,
            size: newpagesize,
            page: page || 1,
            onlySubscribed: selectedFilters.onlySubscribed ? 1 : 0,
            attributename: urlSearchParams.current.attributename || "",
        };
    };

    const buildPayloadForSave = (selectedFilters, newpagesize, userDatabase = []) => {
        // yardımcı: dizi -> { typename, attributename, searchkeyword }
        const toObjArray = (arr, attrName) => {
            if (!Array.isArray(arr)) return [];
            return arr.map(v => (typeof v === "object" && v.searchkeyword)
                ? { typename: "publicationtypeInfo", attributename: v.attributename || attrName, searchkeyword: v.searchkeyword, noinclude: v.noinclude ?? "" }
                : { typename: "publicationtypeInfo", attributename: attrName, searchkeyword: v, noinclude: "" }
            );
        };

        const payload = {
            publicationAdvantageSearchDTOList:
                (selectedFilters.publicationAdvantageSearchDTOList && selectedFilters.publicationAdvantageSearchDTOList.length > 0)
                    ? selectedFilters.publicationAdvantageSearchDTOList
                    : [{
                        typename: "all",
                        attributename: "",
                        searchkeyword: "*",
                        operator: "or"
                    }],
            permission: selectedFilters.permission ?? -1,
            documentTypes: Array.isArray(selectedFilters.documentTypes) ? selectedFilters.documentTypes : [],
            databases: (Array.isArray(selectedFilters.databases) && selectedFilters.databases.length > 0)
                ? selectedFilters.databases
                : (Array.isArray(userDatabase) ? userDatabase : []),

            languages: toObjArray(selectedFilters.languages, "Yayın Dili"),
            journals: toObjArray(selectedFilters.journals, "Dergi Adı"),
            keywords: toObjArray(selectedFilters.keywords, "Anahtar Kelimeler"),
            topicTitles: toObjArray(selectedFilters.topicTitles, "Konu Başlıkları"),

            publishers: Array.isArray(selectedFilters.publishers) ? selectedFilters.publishers : [],
            status: selectedFilters.status ?? 1,
            pdffile: selectedFilters.pdffile ?? -1,
            identifier: selectedFilters.identifier ?? "",

        };


        // start/end year boşsa hiç koyma
        if (selectedFilters.startyear) payload.startyear = selectedFilters.startyear;
        if (selectedFilters.endyear) payload.endyear = selectedFilters.endyear;


        return payload;
    };


    const categoryLabels = {
        keywords: "Anahtar Kelimeler",
        languages: "Diller",
        journals: "Dergi Adı",
        databases: "Veritabanları",
        documentTypes: "Yayın Türleri",
        publishers: "Yayıncılar",
        startyear: "Başlangıç Yılı",
        endyear: "Bitiş Yılı",
    };

    const [selectedSort, setSelectedSort] = useState("relevance");

    const handleSelectAll = () => {
        // O anki sayfadaki yayınlardan seçili olmayanları bul
        const currentPageIds = publications.map(pub => String(pub.mysqlId));
        const notSelected = currentPageIds.filter(id => !selectedArticles.includes(id));
        // Sadece seçili olmayanları ekle
        if (notSelected.length > 0) {
            setSelectedArticles(prev => [...prev, ...notSelected]);
        }
        // Hepsi zaten seçiliyse hiçbir şey yapma
    };
    const [favoriteSavedIds, setFavoriteSavedIds] = useState([]);

    const getFavoritePublications = async () => {
        try {
            //kullanıcnın favori yayınlarına bakarak publicationcarddaki kaydet butonunu işaretli / işaretsiz yap.
            const response = await axiosInstance.get(
                `userpanel/favoritepublicationsListByUserId/1`,
                {
                    headers: headers,
                }
            );

            if (response.data && response.data.status === "OK") {
                setFavoriteSavedIds(response.data.data.map(item => String(item.publication.id)));
            }
        } catch (error) {
            console.error("Favori yayınlar alınırken hata oluştu:", error);
        }
    };


    const handleSaveClick = async (type) => {

        if (type !== "excel" && (!auth || !auth.token)) {
            toast.warning("Bu işlemi gerçekleştirmek için giriş yapmalısınız.");
            return;
        }

        if (type === "multifavorite") {
            // 1. Kullanıcının mevcut favori publication id'lerini çek
            if (selectedArticles.length === 0) {
                toast.info("Lütfen en az bir yayın seçin.");
                return;
            }
            let favoriteIds = [];

            try {
                const response = await axiosInstance.get(
                    `userpanel/favoritepublicationsListByUserId/1`,
                    {
                        headers: headers,
                    }
                );

                if (
                    response.data &&
                    response.data.status === "BAD_REQUEST" &&
                    response.data.message === "Publication not found!"
                ) {
                    // Hiç favori yoksa boş devam et
                    favoriteIds = [];
                } else {
                    favoriteIds = response.data.data.map(item => String(item.publication.id));
                }

            } catch (err) {
                // Eğer hata varsa ve mesaj 'Publication not found!' değilse kullanıcıya bildir
                if (
                    err.response &&
                    err.response.data &&
                    err.response.data.message === "Yayın bulunamadı!"
                ) {
                    favoriteIds = [];
                } else {
                    toast.error(err.response?.data?.message || "Favori yayınlar alınamadı. Lütfen tekrar deneyin.");
                    return;
                }
            }

            // 2. Sadece yeni olanları bul
            const toSave = publications.filter(
                pub => selectedArticles.includes(String(pub.mysqlId)) && !favoriteIds.includes(String(pub.mysqlId))
            );

            // 3. Sadece yenileri ekle
            if (toSave.length > 0) {
                const success = await handleMultipleAddToFavorites(toSave);
                getFavoritePublications(); // Favori listeyi güncelle

                if (!success) {
                    return; // Hata varsa modal açma
                }
            }


            // if (toSave.length < selectedArticles.length) {
            //     if (toSave.length === 0) {
            //         toast.info("Seçili yayınlar zaten kütüphanede.");
            //     } else {
            //         toast.info(`${selectedArticles.length - toSave.length} yayın zaten kütüphanede vardı.`);
            //     }
            // }
            setSaveSummary({
                total: selectedArticles.length,
                added: toSave.length,
                existing: selectedArticles.length - toSave.length,
            });
            setSaveMode('multi');
            setSaveTargetIds(selectedArticles.map(id => Number(id)));
            setShowSaveModal(true);
            return;
        }

        if (type === "search") {
            try {
                const payload = buildPayloadForSave(selectedFilters, selectedSort, newpagesize, userDatabase);
                await axiosInstance.post(
                    "publications/saveQuery",
                    {
                        query: payload,
                        searchurl: "/publication-list?" + queryString.stringify(buildQueryForURL(selectedFilters, selectedSort, newpagesize, currentPage), { arrayFormat: "none" }),
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${auth.token}`,
                            "Content-Type": "application/json"
                        }
                    }
                );
                toast.success("Arama başarıyla kaydedildi.");
            } catch (err) {
                toast.error(err.response?.data?.message || "Arama kaydedilemedi. Lütfen tekrar deneyin.");
            }
            return;
        }
        if (type === "excel") {
            try {
                const filterSearchParameters = { ...selectedFilters };
                ["languages", "keywords", "topicTitles", "journals"].forEach((key) => {
                    if (Array.isArray(filterSearchParameters[key])) {
                        filterSearchParameters[key] = filterSearchParameters[key].map(obj => ({
                            ...obj,
                            noinclude: obj.noinclude ?? ""
                        }));
                    }
                });
                if (!filterSearchParameters.startyear) delete filterSearchParameters.startyear;
                if (!filterSearchParameters.endyear) delete filterSearchParameters.endyear;
                Object.keys(filterSearchParameters).forEach(key => {
                    if (filterSearchParameters[key] == null) delete filterSearchParameters[key];
                });

                const { ordertype, orderfield } = sortMapping[selectedSort] || {};

                let ids = [];
                if (selectedArticles.length > 0) {
                    ids = selectedArticles.map(String);
                } else {
                    ids = [];
                }


                const requestBody = {
                    filterSearchParameters,
                    ids
                };

                const exportUrl = ids.length > 0
                    ? "publicationSearch/export/excel"
                    : `publicationSearch/export/excel?size=${newpagesize}`;

                const response = await axiosInstance.post(
                    exportUrl,
                    requestBody,
                    {
                        params: {
                            orderfield: orderfield,
                            ordertype: ordertype,
                        },
                        headers: {
                            Authorization: `Bearer ${auth.token}`,
                            "Content-Type": "application/json"
                        },
                        responseType: 'blob',
                    }
                );

                // Download the Excel file
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'publications.xlsx');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                toast.success("Excel başarıyla indirildi.");
            } catch (err) {
                toast.error("Excel indirilemedi. Lütfen tekrar deneyin.");
            }
        }
    };

    const handleShareSearch = () => {
        const queryObj = buildQueryForURL(selectedFilters, selectedSort, newpagesize, currentPage);
        const fullUrl = window.location.origin + window.location.pathname + "?" +
            queryString.stringify(queryObj, { arrayFormat: "none" });

        navigator.clipboard
            .writeText(fullUrl)
            .then(() => toast.success("Arama bağlantısı kopyalandı!"))
            .catch(() => toast.error("Bağlantıyı kopyalarken hata oluştu."));
    };


    // Sadece state güncelleyen fonksiyonlar!
    const handlePageChange = (page) => setCurrentPage(page);
    const handleSortChange = (sortType) => {
        setSelectedSort(sortType);
        setCurrentPage(1); // Sıralama değiştiğinde sayfa 1'e dön
    };
    const handlePageSizeChange = (size) => {
        setNewPageSize(size);
        setCurrentPage(1); // Sayfa boyutu değiştiğinde sayfa 1'e dön
    };

    useEffect(() => {
        // setPublications([]);
        const params = queryString.parse(location.search, { arrayFormat: 'none' });

        // Eğer params içinde string olarak geliyorsa, array'e çevir:
        const toArray = (param, splitByComma = false) => {
            if (!param || param === "") return [];
            if (Array.isArray(param)) return param;
            if (splitByComma && typeof param === "string") {
                return param.split(",").map(x => x.trim()).filter(Boolean);
            }
            return [param];
        };

        const toObjArray = (arr, typename, attributename) => {
            if (!arr) return [];
            return arr.map(value =>
                typeof value === "object"
                    ? value
                    : {
                        typename,
                        attributename,
                        searchkeyword: value
                    }
            );
        };

        const parsedFilters = {
            publicationAdvantageSearchDTOList: (() => {
                const raw = params.publicationAdvantageSearchDTOList;
                if (!raw) return [];
                try {
                    // çoğu durumda yeterli
                    return JSON.parse(raw);
                } catch {
                    // nadiren çift kodlanmış olabilir
                    try { return JSON.parse(decodeURIComponent(raw)); }
                    catch { return []; }
                }
            })(),
            permission: params.permission ? parseInt(params.permission) : -1,
            documentTypes: toArray(params.documentTypes, true),
            databases: toArray(params.databases, true),
            languages: toObjArray(toArray(params.languages, false), "publicationtypeInfo", "Yayın Dili"),
            journals: toObjArray(toArray(params.journals, false), "publicationtypeInfo", "Dergi Adı").map(j => {
                const isIssn = params.attributename === "ISSN" || params.attributename === "E-ISSN" || params.attributename === "EISSN";
                if (isIssn) {
                    const exactAttr = (params.attributename === "E-ISSN" || params.attributename === "EISSN") ? "E-ISSN" : "ISSN";
                    return { ...j, attributename: exactAttr };
                }
                const isRegIssn = /^\d{4}-?\d{3}[\dX]$/i.test((j.searchkeyword || "").toString().trim());
                if (isRegIssn) {
                    return { ...j, attributename: "ISSN" };
                }
                return j;
            }),
            keywords: toObjArray(toArray(params.keywords, false), "publicationtypeInfo", "Anahtar Kelimeler"),
            publishers: toArray(params.publishers, false),
            topicTitles: toObjArray(toArray(params.topicTitles, false), "publicationtypeInfo", "Konu Başlıkları"),
            startyear: params.startyear || "",
            endyear: params.endyear || "",
            status: params.status ? parseInt(params.status) : 1,
            pdffile: params.pdffile ? parseInt(params.pdffile) : -1,
            identifier: params.identifier || "",
            onlySubscribed: params.onlySubscribed === "1",
        };

        const parsedSort = (() => {
            const s = params.sort || "relevance";
            return (ALLOWED_SORTS || []).includes(s) ? s : "relevance";
        })();

        const parsedSize = (() => {
            const n = parseInt(params.size, 10);
            return (ALLOWED_SIZES || []).includes(n) ? n : 20;
        })();

        const parsedPage = Math.max(1, parseInt(params.page, 10) || 1);

        setSelectedSort(parsedSort);
        setNewPageSize(parsedSize);
        setCurrentPage(parsedPage);

        // Sync the visible search input and the displayed result keyword from URL params
        try {
            const dtoList = Array.isArray(parsedFilters.publicationAdvantageSearchDTOList)
                ? parsedFilters.publicationAdvantageSearchDTOList
                : parsePublicationAdvantageSearchDTOList(parsedFilters.publicationAdvantageSearchDTOList);
            
            const issnJournal = parsedFilters.journals?.find(j => j.attributename === "ISSN" || j.attributename === "E-ISSN");
            const sk = issnJournal
                ? issnJournal.searchkeyword
                : ((dtoList && dtoList.length > 0) ? (dtoList[0].searchkeyword || "") : "");
            
            const displayKeywordFromUrl = sk === '*' ? '' : sk;
            setSearchInput(displayKeywordFromUrl);
            setLastSearchKeyword(displayKeywordFromUrl);

            // Store attributename for dropdown selection
            if (issnJournal) {
                urlSearchParams.current = {
                    attributename: issnJournal.attributename
                };
            } else if (dtoList && dtoList.length > 0) {
                urlSearchParams.current = {
                    attributename: dtoList[0].attributename || ""
                };
            }
        } catch (e) {
            // ignore sync failures
        }

        setSelectedFilters(parsedFilters);
        fetchPublications(parsedPage, parsedSort, parsedSize);
        // setCurrentPage(1); // Sayfayı 1'e resetle
    }, [location.search]);

    // URL'den gelen arama kelimesi ve kategori seçimini inputlara yansıt
    const urlSyncInitialized = useRef(false);
    useEffect(() => {
        const params = queryString.parse(location.search, { arrayFormat: 'none' });
        let searchkeyword = "";
        let attributename = "";

        const toArray = (param, splitByComma = false) => {
            if (!param || param === "") return [];
            if (Array.isArray(param)) return param;
            if (splitByComma && typeof param === "string") {
                return param.split(",").map(x => x.trim()).filter(Boolean);
            }
            return [param];
        };
        const urlJournals = toArray(params.journals, false);
        const issnVal = urlJournals.find(val => /^\d{4}-?\d{3}[\dX]$/i.test((val?.searchkeyword || val || "").toString().trim()) ||
                                               params.attributename === "ISSN" ||
                                               params.attributename === "E-ISSN" ||
                                               params.attributename === "EISSN");

        if (issnVal) {
            searchkeyword = issnVal?.searchkeyword || issnVal || "";
            attributename = (params.attributename === "E-ISSN" || params.attributename === "EISSN") ? "E-ISSN" : "ISSN";
        } else {
            try {
                const arr = parsePublicationAdvantageSearchDTOList(params.publicationAdvantageSearchDTOList);
                if (arr && arr.length > 0) {
                    searchkeyword = arr[0].searchkeyword || "";
                    attributename = arr[0].attributename || "";
                }
            } catch (e) {
                // nothing
            }
        }

        // Only overwrite visible input on the first sync, or when the URL contains a non-empty keyword.
        if (!urlSyncInitialized.current) {
            setSearchInput(searchkeyword);
            setLastSearchKeyword(searchkeyword);
            urlSyncInitialized.current = true;
        } else if (searchkeyword && searchkeyword !== "") {
            setSearchInput(searchkeyword);
            setLastSearchKeyword(searchkeyword);
        }

        // Find the dropdown option based on attributename
        let found = null;
        if (options && options.length > 0) {
            // Use attributename from URL params
            const { attributename: urlAttributename } = urlSearchParams.current;
            if (urlAttributename) {
                found = options.find(opt => opt.attributename === urlAttributename);
            }
            if (!found && attributename) {
                found = options.find(opt => opt.attributename === attributename);
            }
            if (found) {
                setSelectedOption(found);
            }
        }
    }, [location.search, options]);


    // --- selectedFilters değişince URL'yi güncelle ---
    useEffect(() => {
        if (isFirstLoad.current) {
            isFirstLoad.current = false;
            return;
        }
        // Query string'i oluştur
        const q = buildQueryForURL(selectedFilters, selectedSort, newpagesize, currentPage);
        const newSearch = "?" + queryString.stringify(q, { arrayFormat: "none" });
        if (location.search !== newSearch) {
            navigate({ pathname: location.pathname, search: newSearch }, { replace: true });
        }
    }, [selectedFilters, selectedSort, newpagesize, currentPage]);

    useEffect(() => {
        if (userDatabase === null) return;
        setPublications([]);
        fetchPublications(currentPage, selectedSort, newpagesize);
    }, [userDatabase]);

    const [yearInputs, setYearInputs] = useState({
        startyear: "",
        endyear: ""
    });
    const [yearError, setYearError] = useState(null);

    // selectedFilters'i güncellerken yıl inputlarını doğrudan değiştirme!
    const handleYearInputChange = (field, value) => {
        setYearInputs(prev => ({ ...prev, [field]: value }));
        // clear previous year error when user edits inputs
        if (yearError) setYearError(null);
    };

    const handleYearApply = () => {
        // validate years before applying so invalid ranges are not added to selected filters
        const minYear = 1965;
        const maxYear = 2099;
        const start = yearInputs.startyear !== "" ? parseInt(yearInputs.startyear, 10) : null;
        const end = yearInputs.endyear !== "" ? parseInt(yearInputs.endyear, 10) : null;

        if (start !== null && isNaN(start)) {
            const msg = "Geçersiz başlangıç yılı!";
            setYearError(msg);
            toast.error(msg);
            return;
        }
        if (end !== null && isNaN(end)) {
            const msg = "Geçersiz bitiş yılı!";
            setYearError(msg);
            toast.error(msg);
            return;
        }
        if (start !== null && end !== null && start > end) {
            const msg = "Başlangıç yılı, bitiş yılından büyük olamaz!";
            setYearError(msg);
            toast.error(msg);
            return;
        }
        if (start !== null && (start < minYear || start > maxYear)) {
            const msg = `Başlangıç yılı ${minYear} ile ${maxYear} arasında olmalı.`;
            setYearError(msg);
            toast.error(msg);
            return;
        }
        if (end !== null && (end < minYear || end > maxYear)) {
            const msg = `Bitiş yılı ${minYear} ile ${maxYear} arasında olmalı.`;
            setYearError(msg);
            toast.error(msg);
            return;
        }

        // valid -> clear any existing error and apply
        if (yearError) setYearError(null);
        setSelectedFilters(prev => ({
            ...prev,
            startyear: yearInputs.startyear,
            endyear: yearInputs.endyear
        }));
        setCurrentPage(1); // Yıl filtresi değiştiğinde sayfa 1'e dön
    };

    // Filtre, sayfa, sıralama, page size değişirse publication çekilsin
    // useEffect(() => {
    //     setPublications([]);
    //     fetchPublications(currentPage, selectedSort, newpagesize);
    // }, [currentPage, selectedSort, newpagesize]);

    // Scroll to top automatically when any search/request-related state changes
    // (filters, page, sort, page size). Skip the very first load to avoid
    // jumping the user on initial render — reuse the existing isFirstLoad ref.
    useEffect(() => {
        if (isFirstLoad.current) return;
        try {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (e) {
            // fallback for environments where window.scrollTo may not be available
            window.scrollTo(0, 0);
        }
    }, [selectedFilters, currentPage, selectedSort, newpagesize]);

    useEffect(() => {
        setYearInputs({
            startyear: selectedFilters.startyear || "",
            endyear: selectedFilters.endyear || ""
        });
    }, [selectedFilters.startyear, selectedFilters.endyear]);

    const removeFromFavoritesAndAllFolders = async (pubId) => {
        // 1) Favorilerden kaldır
        const favRecId = pubId
        if (favRecId) {
            await deleteFavoritePublication(favRecId, auth.token);
        }

        // 2) Tüm klasörlerden kaldır
        const foldersRes = await getUserFolders(0, 100, auth.token); // service response'ı direk return ediyordu
        const folders = foldersRes?.data?.data || [];
        await Promise.all(
            folders.map(f =>
                updateFolderPublicationStatus(f.id, pubId, -1, auth.token)
                    .catch(() => null) // tek tek hata verirse akışı durdurmasın
            )
        );

        // 3) UI'yı güncelle
        setFavoriteSavedIds(prev => prev.filter(x => x !== String(pubId)));
    };

    const startIndex = Math.max((currentPage - 1) * newpagesize + 1, 1);
    const endIndex = Math.min(currentPage * newpagesize, paginatedTotalPublication);

    // Sadece arama metni ve 'için' kısmı kısaltılır, sonuç sayısı ve aralık her zaman tam görünür
    const formatSearchKeyword = (keyword) => {
        if (!keyword || keyword === "*") return "";
        // Eğer kelime 50 karakterden uzunsa, kısalt (tırnaksız)
        // return keyword.length > 60 ? `${keyword.substring(0, 60)}...` : keyword;
        return `"${keyword}"`;
    };

    const resultText = (lastSearchKeyword && lastSearchKeyword !== "*") ? (
        <>
            <span className="flex-grow-1 text-truncate" style={{ minWidth: 0 }}>
                <b><i>{formatSearchKeyword(lastSearchKeyword)}</i></b>
            </span>
            <span className="ms-2 text-nowrap">
                <b>{totalPublication.toLocaleString("tr-TR")}</b> sonuç, <b>{startIndex}</b> - <b>{endIndex}</b> kayıt gösteriliyor.
            </span>
        </>
    ) : (
        <span className="text-nowrap">
            <b>{totalPublication.toLocaleString("tr-TR")}</b> sonuç bulundu. <b>{startIndex}</b> - <b>{endIndex}</b> kayıt gösteriliyor.
        </span>
    );

    const getContentToRender = () => {
        // 1. Hala yükleniyorsa
        if (loading) {
            return (
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        background: "rgba(255,255,255,0.7)",
                        zIndex: 10,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    aria-live="polite"
                    aria-busy="true"
                >
                    <div className="spinner-border text-primary mt-5" role="status">
                        <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                </div>
            );
        }

        // 2. Yükleme bitti ve sonuç yoksa
        if (isLanded && Array.isArray(publications) && publications.length === 0) {
            return (
                <div className="w-100 d-flex align-items-center justify-content-center">
                    <div className="text-center border rounded-3 bg-light p-4 my-4" style={{ maxWidth: 520 }}>
                        <i className="fa-regular fa-folder-open mb-2" style={{ fontSize: 24 }} />
                        <div className="fw-semibold">Yayın Bulunamadı</div>
                        <div className="text-muted small mt-1">
                            Filtreleri genişletmeyi, arama terimini değiştirmeyi veya "Sadece abone olunanlar" seçimini kapatmayı deneyin.
                        </div>
                    </div>
                </div>
            );
        }

        // 3. Sonuçlar varsa
        if (!loading && publications?.length > 0) {
            return (
                <div className="row">
                    {publications.map((pub) => (
                        <div className="col-12 px-2 px-md-3 small" key={pub.mysqlId}>
                            <PublicationCard
                                pub={pub}
                                selected={selectedArticles.includes(String(pub.mysqlId))}
                                onSelect={() => handleCheckboxChange2(pub.mysqlId)}
                                onDetails={() => navigate(`/publication-details/${pub.mysqlId}`)}
                                onCite={() => {/* modal açma vs. */ }}
                                onRelated={() => { }}
                                onAddToLibrary={handleSingleSaveWithModal}
                                favoriteSavedIds={favoriteSavedIds}
                                onKeywordClick={handleKeywordClick}
                                coral="#fc7f50"
                                userinstDatabases={userDatabase}
                                isSummaryOpen={openSummaryId === pub.mysqlId}
                                onToggleSummary={() =>
                                    setOpenSummaryId(prev => (prev === pub.mysqlId ? null : pub.mysqlId))
                                }
                                onRemoveSaved={handleRequestRemoveSaved}
                            />
                        </div>
                    ))}
                </div>
            );
        }

        // 4. Hiçbiri değilse (initial state) - loading göster
        return (
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    background: "rgba(255,255,255,0.7)",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
                aria-live="polite"
                aria-busy="true"
            >
                <div className="spinner-border text-primary mt-5" role="status">
                    <span className="visually-hidden">Yükleniyor...</span>
                </div>
            </div>
        );
    };


    return (
        <>
            <Helmet>
                <title>İdealonline - Yayın Listesi</title>
            </Helmet>
            <div className="main-wrapper">
                <Header />
                <section className="course-content px-lg-5">
                    <div className="py-1 my-2 mb-0 mx-4 justify-content-center">
                        <div className="container d-lg-none">
                            <form onSubmit={handleSearchSubmit} role="search" className="my-2">
                                <div className="input-group input-group-sm bg-white border rounded-2 overflow-hidden">
                                    <select
                                        className="form-select border-0 shadow-none"
                                        style={{ maxWidth: 150 }}
                                        value={selectedOption ? selectedOption.value : ""}
                                        onChange={(e) => {
                                            const selected = options.find(opt => opt.value === e.target.value);
                                            setSelectedOption(selected || null);
                                        }}
                                        aria-label="Kategori"
                                        disabled={loading}
                                    >
                                        {options.map(opt => (
                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </select>
                                    <input
                                        type="text"
                                        className="form-control border-0"
                                        placeholder="Arama yap..."
                                        name="query"
                                        autoComplete="off"
                                        value={searchInput}
                                        onChange={(e) => setSearchInput(e.target.value)}
                                        aria-label="Arama"
                                    // disabled={loading}
                                    />
                                    <button
                                        type="submit"
                                        className="btn btn-primary d-flex align-items-center px-3"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <div className="spinner-border spinner-border-sm text-white" role="status">
                                                <span className="visually-hidden">Yükleniyor...</span>
                                            </div>
                                        ) : (
                                            <i className="fa-solid fa-magnifying-glass" />
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>

                        {/* Desktop: sol filtre kolonunun üstü boş; arama sağ kolonda, kartlarla hizalı */}
                        <div className="container-fluid d-none d-lg-block mt-3 mb-1">
                            <div className="row g-0 align-items-center">
                                {/* Sol boşluk yerine kurum logosu */}
                                <div className="col-lg-2 d-flex align-items-center justify-content-center">
                                    {instLogoUrl ? (
                                        <img
                                            src={instLogoUrl}
                                            alt={instObj?.name || "Kurum Logosu"}
                                            loading="lazy"
                                            draggable={false}
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: 64,
                                                objectFit: "contain",
                                                filter: "grayscale(40%)",
                                                opacity: 0.80,
                                                mixBlendMode: "multiply",
                                                paddingRight: "2.5rem"
                                            }}
                                            title={instObj?.name || ""}
                                        />
                                    ) : (
                                        // logo yoksa boşluğu koru ya da hafif placeholder
                                        <div style={{ height: 64 }} />
                                    )}
                                </div>
                                <div className="col-lg-10">
                                    {/* arama formu ... */}

                                    <form onSubmit={handleSearchSubmit} role="search" className="my-2">
                                        <div className="input-group input-group-sm bg-white border rounded-3 overflow-hidden">
                                            <select
                                                className="mx-2 border-0"
                                                style={{ maxWidth: 180 }}
                                                value={selectedOption ? selectedOption.value : ""}
                                                onChange={(e) => {
                                                    const selected = options.find(opt => opt.value === e.target.value);
                                                    setSelectedOption(selected || null);
                                                }}
                                                aria-label="Kategori"
                                                disabled={loading}
                                            >
                                                {options.map(opt => (
                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                ))}
                                            </select>
                                            <input
                                                type="text"
                                                className="form-control border-0"
                                                placeholder="Arama yap..."
                                                name="query"
                                                autoComplete="off"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                aria-label="Arama"
                                            // disabled={loading}
                                            />
                                            <button
                                                type="submit"
                                                className="btn btn-primary d-flex align-items-center px-3"
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <div className="spinner-border spinner-border-sm text-white" role="status">
                                                        <span className="visually-hidden">Yükleniyor...</span>
                                                    </div>
                                                ) : (
                                                    <i className="fa-solid fa-magnifying-glass" />
                                                )}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        {/* Mobilde filtre ve aksiyon butonları yan yana */}
                        <div className="row g-2 d-lg-none mt-4 ">
                            <div className="col-6">
                                <button
                                    className="btn btn-badgeblue btn-sm w-100 d-flex align-items-center justify-content-center"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#filterPanelCollapseMobile"
                                    aria-expanded="false"
                                    aria-controls="filterPanelCollapseMobile"
                                >
                                    <FeatherIcon icon="filter" className="me-2" />
                                    Filtreleri Göster/Gizle
                                </button>
                            </div>
                            <div className="col-6">
                                <button
                                    className="btn btn-badgeblue btn-sm w-100 d-flex align-items-center justify-content-center"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#sortActionsCollapseMobile"
                                    aria-expanded="false"
                                    aria-controls="sortActionsCollapseMobile"
                                >
                                    <i className="fa fa-sort me-2 " />
                                    Sıralama ve Aksiyonlar
                                </button>
                            </div>
                        </div>

                        {/* Collapse panelleri butonların hemen altına koy */}
                        <div className="row d-lg-none">
                            <div className="col-12">
                                <div className="collapse mt-2" id="filterPanelCollapseMobile">
                                    <div className="bg-default-color shadow-sm rounded-4 px-2 py-3 px-md-3 py-md-4">
                                        <FilterPanel
                                            filters={filters}
                                            selectedFilters={selectedFilters}
                                            onCheckboxChange={handleCheckboxChange}
                                            onYearChange={handleYearInputChange}
                                            onYearApply={handleYearApply}
                                            onClearFilters={clearFilters}
                                            onResultCountChange={option => setNewPageSize(Number(option.value))}
                                            resultCountOptions={optionSonucSayisi}
                                            resultCount={newpagesize}
                                            expandedCategory={expandedCategory}
                                            onExpandCategory={handleExpandCategory}
                                            extraFilters={extraFilters}
                                            loadingFilters={Object.keys(filters).length === 0 || loading}
                                            yearInputs={yearInputs} // yeni prop
                                            fetchAggrItems={fetchAggrItems} // yeni prop
                                            onApplyModalSelections={handleApplyModalSelections}
                                            userDatabase={userDatabase}
                                        />
                                    </div>
                                </div>
                                <div className="collapse mt-4" id="sortActionsCollapseMobile">
                                    <SortAndActionsBar
                                        onSortChange={handleSortChange}
                                        onSaveClick={handleSaveClick}
                                        onSelectAll={handleSelectAll}
                                        onShareSearch={handleShareSearch}
                                        onPageSizeChange={handlePageSizeChange}
                                        selectedSort={selectedSort}
                                        selectedPageSize={newpagesize}
                                        selectedFilters={selectedFilters}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="container-fluid px-1 px-sm-2 px-md-4 py-2 py-md-4">
                        <div className="row g-3 align-items-start flex-nowrap">
                            {/* ----------- SOL: FilterPanel Buton ----------- */}
                            <div className="col-12 col-lg-2 order-2 order-lg-1 mb-3 mb-lg-0 pe-lg-3"
                                style={{ minWidth: 200 }}>


                                {/* FilterPanel collapse paneli butonun hemen ALTINDA olacak LG filter */}
                                <div className="collapse d-lg-block d-md-none">
                                    <div className="rounded-4 px-2 py-3 px-md-3 py-md-2 mt-lg-0">
                                        <FilterPanel
                                            filters={filters}
                                            selectedFilters={selectedFilters}
                                            onCheckboxChange={handleCheckboxChange}
                                            onYearChange={handleYearInputChange}
                                            onYearApply={handleYearApply}
                                            onClearFilters={clearFilters}
                                            onResultCountChange={option => setNewPageSize(Number(option.value))}
                                            resultCountOptions={optionSonucSayisi}
                                            resultCount={newpagesize}
                                            expandedCategory={expandedCategory}
                                            onExpandCategory={handleExpandCategory}
                                            extraFilters={extraFilters}
                                            loadingFilters={Object.keys(filters).length === 0 || loading}
                                            yearInputs={yearInputs} // yeni prop
                                            fetchAggrItems={fetchAggrItems} // yeni prop
                                            onApplyModalSelections={handleApplyModalSelections}
                                            userDatabase={userDatabase}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* ----------- SAĞ: Ana İçerik ----------- */}
                            <div className="col-12 col-lg-10 order-lg-2">
                                {/* Arama ve Kategori */}

                                {/* Seçili Filtreler */}
                                <div className="selected-filters d-flex flex-wrap mb-2">
                                    {(!yearError && (selectedFilters.startyear || selectedFilters.endyear)) && (
                                        <div className="d-flex flex-wrap align-items-center mb-2 ms-2">
                                            <div className="badge text-xs fw-normal me-2 d-flex align-items-center mb-2 mt-1"
                                                style={{ cursor: "pointer", background: "#dbeafe", color: "#1d4ed8" }}
                                                onClick={() => {
                                                    // ikisini birden temizleyelim
                                                    setSelectedFilters(prev => ({ ...prev, startyear: "", endyear: "" }));
                                                    setCurrentPage(1); // Yıl filtresi temizlendiğinde sayfa 1'e dön
                                                }}>
                                                Tarih Aralığı : {selectedFilters.startyear || "…"} - {selectedFilters.endyear || "…"}
                                                <FeatherIcon icon="x" className="ms-1" size={12} style={{ marginLeft: 5 }} />
                                            </div>
                                        </div>
                                    )}
                                    {Object.entries(selectedFilters).map(([category, values]) =>
                                        Array.isArray(values) && values.length > 0 && category !== "publicationAdvantageSearchDTOList" ? (
                                            <div key={category} className="d-flex flex-wrap align-items-center mb-2 ms-2">
                                                {(() => {
                                                    const lower = (s) => (String(s || '').toLowerCase());
                                                    if (category === 'databases') {
                                                        const journalDbVariants = ['akademik dergiler', 'popüler dergiler', 'populer dergiler'];

                                                        const hasJournalDbs = values.some(v => journalDbVariants.includes(lower(v)));
                                                        const otherDbs = values.filter(v => !journalDbVariants.includes(lower(v)));

                                                        const display = [];
                                                        if (hasJournalDbs) display.push('İdealonline Süreli Yayınlar');
                                                        otherDbs.forEach(d => display.push(d));

                                                        return display.map((label, index) => (
                                                            <div
                                                                key={index}
                                                                className="badge text-xs fw-normal me-2 d-flex align-items-center mb-2 mt-1"
                                                                style={{ cursor: "pointer", background: "#dbeafe", color: "#1d4ed8" }} // DB'ler için mavi tonu
                                                                onClick={() => removeFilter(category, label)}
                                                            >
                                                                Veritabanı : {label}
                                                                <FeatherIcon icon="x" className="ms-1" size={12} style={{ marginLeft: 5 }} />
                                                            </div>
                                                        ));
                                                    }
                                                    // For documentTypes we want to merge akademik/populer variants for display
                                                    if (category === 'documentTypes') {
                                                        const lower = (s) => (String(s || '').toLowerCase());
                                                        const bookVariants = ['akademik kitap', 'popüler kitap', 'populer kitap'];
                                                        const bookSectionVariants = ['akademik kitap bölümü', 'popüler kitap bölümü', 'populer kitap bolumu', 'populer kitap bölümü', 'akademik kitap bolumu'];

                                                        const hasBook = values.some(v => bookVariants.includes(lower(v)));
                                                        const hasBookSection = values.some(v => bookSectionVariants.includes(lower(v)));
                                                        const others = values.filter(v => !bookVariants.includes(lower(v)) && !bookSectionVariants.includes(lower(v)));
                                                        const display = [];
                                                        if (hasBook) display.push('Kitap');
                                                        if (hasBookSection) display.push('Kitap Bölümü');
                                                        others.forEach(o => {
                                                            const lbl = o?.searchkeyword || o;
                                                            if (!display.includes(lbl)) display.push(lbl);
                                                        });
                                                        return display.map((label, index) => (
                                                            <div
                                                                key={index}
                                                                className="badge text-xs fw-normal me-2 d-flex align-items-center mb-2 mt-1"
                                                                style={{ cursor: "pointer", background: "#43d4a9af", color: "#0E7355" }}
                                                                onClick={() => removeFilter(category, label)}
                                                            >
                                                                {(/^\d{4}-?\d{3}[\dX]$/i.test((label || "").toString().trim()) ? "ISSN" : (categoryLabels[category] || category))} : {label}
                                                                <FeatherIcon icon="x" className="ms-1" size={12} style={{ marginLeft: 5 }} />
                                                            </div>
                                                        ));
                                                    }

                                                    // default rendering for other categories
                                                    return values.map((filter, index) => {
                                                        const label = filter?.searchkeyword || filter;
                                                        return (
                                                            <div
                                                                key={index}
                                                                className="badge text-xs fw-normal me-2 d-flex align-items-center mb-2 mt-1"
                                                                style={{ cursor: "pointer", background: "#43d4a9af", color: "#0E7355" }}
                                                                onClick={() => removeFilter(category, label)}
                                                            >
                                                                {(/^\d{4}-?\d{3}[\dX]$/i.test((label || "").toString().trim()) ? "ISSN" : (categoryLabels[category] || category))} : {label}
                                                                <FeatherIcon icon="x" className="ms-1" size={12} style={{ marginLeft: 5 }} />
                                                            </div>
                                                        );
                                                    });
                                                })()}
                                            </div>
                                        ) : null
                                    )}
                                </div>

                                <hr />

                                <div className="show-result d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-start gap-2 mb-3 mt-2 mx-1">

                                    {/* Sol taraf: sıralama ve toplu işlemler */}
                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                        <div className="d-none d-lg-block flex-shrink-0">
                                            <SortAndActionsBar
                                                selectedSort={selectedSort}
                                                onSortChange={handleSortChange}
                                                onSaveClick={handleSaveClick}
                                                onSelectAll={handleSelectAll}
                                                onShareSearch={handleShareSearch}
                                                selectedPageSize={newpagesize}
                                                onPageSizeChange={handlePageSizeChange}
                                                selectedFilters={selectedFilters}
                                            />
                                        </div>

                                        {selectedArticles.length > 0 && (
                                            <div className="ms-0 ms-lg-2 d-flex align-items-center gap-2">
                                                <span className="text-muted text-xs">
                                                    <b>{selectedArticles.length}</b> seçili.
                                                </span>
                                                <button
                                                    className="btn btn-badgeblue btn-sm"
                                                    style={{ fontSize: "0.80em" }}
                                                    onClick={() => setSelectedArticles([])}
                                                >
                                                    Temizle
                                                </button>
                                            </div>
                                        )}
                                    </div>

                                    {/* Sağ taraf: sadece anahtar kelime kısalır */}

                                    <div className="d-flex align-items-center text-fume text-xs fw-normal mb-0 flex-nowrap gap-2"
                                        style={{ minWidth: 0, overflow: "hidden" }}
                                    >
                                        {resultText}
                                    </div>




                                    {/* Üstteki mini pagination aynı satırda ve aktif kutucuklu */}
                                    {!loading && (

                                        <ul className="d-flex flex-row ms-lg-auto me-1 mb-0 list-unstyled pagination">
                                            <li className={`first ${currentPage === 1 ? "disabled" : ""}`}>
                                                <button
                                                    className="btn btn-outline-primary btn-sm text-xs me-2"
                                                    onClick={() => handlePageChange(1)}
                                                    disabled={currentPage === 1}
                                                >
                                                    {"<<"}
                                                </button>
                                            </li>
                                            <li className={`prev ${currentPage === 1 ? "disabled" : ""}`}>
                                                <button
                                                    className="btn btn-outline-primary btn-sm text-xs me-2"
                                                    onClick={() => handlePageChange(currentPage - 1)}
                                                    disabled={currentPage === 1}
                                                >
                                                    <i className="fas fa-angle-left" />
                                                </button>
                                            </li>
                                            {/* Aktif sayfa kutucuğu */}
                                            <li className="active">
                                                <span className="btn btn-sm text-xs btn-primary active fw-bold me-2" style={{ minWidth: 25, display: 'inline-block', textAlign: 'center', pointerEvents: 'none' }}>{currentPage}</span>
                                            </li>
                                            <li className={`next ${currentPage === totalPages ? "disabled" : ""}`}>
                                                <button
                                                    className="btn btn-outline-primary btn-sm text-xs me-2"
                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <i className="fas fa-angle-right" />
                                                </button>
                                            </li>
                                            <li className={`last ${currentPage === totalPages ? "disabled" : ""}`}>
                                                <button
                                                    className="btn btn-outline-primary btn-sm text-xs me-2"
                                                    onClick={() => handlePageChange(totalPages)}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    {">>"}
                                                </button>
                                            </li>
                                        </ul>
                                    )}
                                </div>

                                <SaveModal
                                    show={showSaveModal}
                                    onHide={() => closeSaveModal()}
                                    folders={kaydetFolders}
                                    savedFolders={kaydetSelectedFolders}
                                    setSavedFolders={setKaydetSelectedFolders}
                                    onToggleFolder={handleToggleFolder}
                                    onCreateFolder={handleCreateFolder}
                                    loading={foldersLoading}
                                    saveSummary={saveSummary}
                                    onAddSinglePublicationToFolder={handleAddSinglePublicationToFolder}
                                />

                                <Modal
                                    show={showDeleteConfirm}
                                    onHide={() => !deletingBusy && setShowDeleteConfirm(false)}
                                    size="md"                        // sm yerine bir tık büyük
                                    centered
                                    dialogClassName="modal-cozy"     // genişlik + padding ayarı
                                    contentClassName="shadow-sm rounded-3"
                                    backdrop={deletingBusy ? "static" : true}
                                    keyboard={!deletingBusy}
                                    aria-labelledby="delete-modal-title"
                                    aria-describedby="delete-modal-desc"
                                >
                                    <Modal.Header closeButton={!deletingBusy} className="border-0">
                                        <Modal.Title as="h6" id="delete-modal-title" className="mb-0">
                                            Kaydedilenlerden Sil
                                        </Modal.Title>
                                    </Modal.Header>

                                    <Modal.Body>
                                        <p id="delete-modal-desc" className="mb-0 text-secondary small" style={{ lineHeight: 1.5 }}>
                                            Bu yayını <strong>kaydedilenlerden</strong> ve <strong>tüm klasörlerinizden</strong> silmek istediğinize emin misiniz?
                                        </p>
                                    </Modal.Body>

                                    <Modal.Footer className="border-0">
                                        <a
                                            href="https://idealonline.com.tr/panel/user/userpublications"
                                            className="btn btn-badgeblue btn-sm me-auto"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Klasörlerime git
                                        </a>
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={() => setShowDeleteConfirm(false)}
                                            disabled={deletingBusy}
                                            autoFocus
                                        >
                                            Vazgeç
                                        </Button>
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={async () => {
                                                setDeletingBusy(true);
                                                try {
                                                    await removeFromFavoritesAndAllFolders(deletingPubId);
                                                    toast.success("Yayın kütüphanenizden ve tüm klasörlerinizden silindi.");
                                                    setShowDeleteConfirm(false);
                                                    setDeletingPubId(null);
                                                } catch {
                                                    toast.error("Silme işleminde bir hata oluştu.");
                                                } finally {
                                                    setDeletingBusy(false);
                                                }
                                            }}
                                            disabled={deletingBusy}
                                        >
                                            {deletingBusy ? "Siliniyor…" : "Evet, sil"}
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                {/* Yayın Kartları */}
                                <div className="row">
                                    <div style={{ position: "relative", minHeight: "400px" }}>
                                        {getContentToRender()}
                                    </div>
                                </div>

                                {/* Sayfalama */}
                                <div className="row">
                                    <div className="col-md-12 mt-2">
                                        {!loading && (
                                            <ul className="pagination lms-page justify-content-center d-flex gap-1">
                                                {/* İlk Sayfa */}
                                                <li className={`page-item first ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm text-xs me-2"
                                                        onClick={() => handlePageChange(1)}
                                                        disabled={currentPage === 1}
                                                    >
                                                        {"<<"}
                                                    </button>
                                                </li>
                                                {/* Önceki */}
                                                <li className={`page-item prev ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm text-xs me-2"
                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                        disabled={currentPage === 1}
                                                    >
                                                        <i className="fas fa-angle-left" />
                                                    </button>
                                                </li>
                                                {/* Sayfa Numaraları */}
                                                {Array.from({ length: Math.min(10, totalPages) }, (_, i) => {
                                                    const startPage = Math.max(1, currentPage - 5);
                                                    const page = startPage + i;
                                                    return (
                                                        page <= totalPages && (
                                                            <li
                                                                key={page}
                                                                className={`page-item ${currentPage === page ? "active" : ""}`}
                                                            >
                                                                <button
                                                                    className={`btn btn-sm text-xs me-2 ${currentPage === page ? "btn-outline-primary fw-bold active" : "btn-outline-primary"}`}
                                                                    onClick={() => handlePageChange(page)}
                                                                >
                                                                    {page}
                                                                </button>
                                                            </li>
                                                        )
                                                    );
                                                })}
                                                {/* Sonraki */}
                                                <li className={`page-item next ${currentPage === totalPages ? "disabled" : ""}`}>
                                                    <button
                                                        className="btn btn-sm text-xs me-2 btn-outline-primary"
                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <i className="fas fa-angle-right" />
                                                    </button>
                                                </li>
                                                {/* Son */}
                                                <li className={`page-item last ${currentPage === totalPages ? "disabled" : ""}`}>
                                                    <button
                                                        className="btn btn-sm text-xs me-2 btn-outline-primary"
                                                        onClick={() => handlePageChange(totalPages)}
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {">>"}
                                                    </button>
                                                </li>
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Footer2 />
                <ToastContainer position="top-right" autoClose={3000} />
            </div>
        </>
    );

};

export default CourseList;